const bookList = {
  'Self Help': [
    {
      title: 'How to win friends and influence people',
      author: 'Dale Carnegie',
      rating: '4.5',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/51ay1jgMBNL._SX302_BO1,204,203,200_.jpg',
    },
    {
      title: 'The 7 Habits of Highly Effective People',
      author: 'Stephen Covey',
      rating: '4.1',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/51HshB5UNCL._SX313_BO1,204,203,200_.jpg',
    },
    {
      title: 'The Subtle Art of Not Giving a F*ck',
      author: 'Mark Manson',
      rating: '3.9',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/516pmXNNmCL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
  ],
  Programming: [
    {
      title: 'Clean Code',
      author: 'Robert Cecil Martin',
      rating: '4.5',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/41zoxjP9lcL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
    {
      title: 'The Pragmatic Programmer',
      author: 'Andy Hunt and Dave Thomas',
      rating: '4.7',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/51yaxPX4BFL._SX360_BO1,204,203,200_.jpg',
    },
    {
      title: 'Code Complete',
      author: 'Steve McConnell',
      rating: '4',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/51mG7wsXnpL._SX198_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
  ],
  Fiction: [
    {
      title: 'Nineteen Eighty-Four',
      author: 'George Orwell',
      rating: '4.2',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/514CVwOrybL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
    {
      title: 'The Great Gatsby',
      author: 'F. Scott Fitzgerald',
      rating: '4',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/41bcg+tkC5L._SY344_BO1,204,203,200_.jpg',
    },
    {
      title: "The Handmaid's Tale",
      author: 'Margaret Atwood',
      rating: '4.1',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/31ACSAlQ1XL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
  ],
  'Sci - Fi': [
    {
      title: 'Dune',
      author: ' Frank Herbert',
      rating: '4.2',
      imageKey:
        'https://images-eu.ssl-images-amazon.com/images/I/41rgl-8wDsL._SY264_BO1,204,203,200_QL40_FMwebp_.jpg',
    },
    {
      title: 'The Left Hand of Darkness',
      author: 'Ursula K. Le Guin',
      rating: '4.1',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/51pl5GdE+iL._SX320_BO1,204,203,200_.jpg',
    },
    {
      title: 'Fahrenheit 451',
      author: 'Ray Bradbury',
      rating: '4',
      imageKey:
        'https://images-na.ssl-images-amazon.com/images/I/41gNoGhGSYL._SX311_BO1,204,203,200_.jpg',
    },
  ],
}

export default bookList
